import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import CheckoutHeader from './checkout/CheckoutHeader';
import ClassicHeader from './store/ClassicHeader';

const Header = () => {
	const { pathname } = useLocation();
	const [searchTransition, setSearchTransition] = useState(false);

	if (pathname === '/cart' || pathname === '/checkout-step-1') {
		return <CheckoutHeader step={1} />;
	} else if (pathname === '/checkout-step-2') {
		return <CheckoutHeader step={2} />;
	} else if (pathname === '/checkout-step-3') {
		return <CheckoutHeader step={3} />;
	} else if (pathname === '/CheckoutSuccess' || pathname === '/CheckoutFailure') {
		return <CheckoutHeader step={4} />;
	} else {
		return <ClassicHeader searchTransition={searchTransition} setSearchTransition={setSearchTransition} />;
	}
};

export default Header;
